// extracted by mini-css-extract-plugin
export default {"container":"S02_container__ZATYc","limiter":"S02_limiter__wErxk"};